import { UserAgentApplication } from "msal";

const msalConfig = {
    auth: {
        clientId: "af6411b1-79d8-43bd-a329-a1e43d30cc57",
        authority: "https://login.microsoftonline.com/8cb7de09-a9b2-435c-b453-2c06a1cb5b6c",
    }, 
    cache: {
        cacheLocation: "localStorage", // Use localStorage for token cache
        storeAuthStateInCookie: false, // Set this to true if you are experiencing issues with logout
    },
    system: {
        navigateFrameWait: 0,
        iframeHashTimeout: 6000,
        iframePingTimeout: 2000,
        iframeReloadTimeout: 28000,
        loadFrameTimeout: 0,
        sso_reload: false, // Set this to false if you experience issues with logout
    },
};

const msalApp = new UserAgentApplication(msalConfig);

export default msalApp;
